import { useState } from 'react';
import { faUserCircle } from '@fortawesome/pro-regular-svg-icons';
import { faClose } from '@fortawesome/pro-solid-svg-icons';
import { Button, Icon, Input } from '@nazka/nazka.mapframe.components';
import { useMutation } from '@tanstack/react-query';

import { forgotPassword } from '@services/auth.service';

function ForgotPassword({
  setShowLoginModal,
  setForgotPassword,
  isLoggingIn,
  loading,
}) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState();

  const forgotPasswordMutation = useMutation({
    mutationFn: async () => {
      await forgotPassword(email);
    },
  });

  return (
    <div className="login-modal">
      <div
        className="login-modal__background"
        onClick={() => setShowLoginModal(false)}
      />
      <div className={`login-modal__content${isLoggingIn || loading ? ' is-loading' : ''}`}>
        <div className="login-modal__content__header">
          <div className="login-modal__content__header__title">
            <Icon icon={faUserCircle} className="login-modal__content__header__title__icon" />
            <h2 className="login-modal__content__header__title__text">
              Wachtwoord opnieuw instellen
            </h2>
          </div>
          <Button
            icon={faClose}
            layout="ghost"
            hover={false}
            className="login-modal__content__header__close"
            onClick={() => {
              setForgotPassword(false);
            }}
          />
        </div>
        <div className="login-modal__content__form">
          {!forgotPasswordMutation.isSuccess && (
            <label
              className={`login-modal__content__form__label${error ? ' login-modal__content__form__label--error' : ''}`}
            >
              E-mailadres
              <Input
                className="login-modal__content__form__label__input"
                value={email}
                onInputChange={(v) => {
                  setEmail(v?.target?.value);
                }}
              />
              {(error || forgotPasswordMutation.isError) && (
                <p className="login-modal__content__form__label__error">
                  {error || 'Er ging iets mis.'}
                </p>
              )}
            </label>
          )}
          {forgotPasswordMutation.isSuccess && (
            <p className="login-modal__content__form__success">
              Een e-mail met resetinstructies is verstuurd. Controleer je inbox en spamfolder.
            </p>
          )}
        </div>
        {!forgotPasswordMutation.isSuccess && (
          <Button
            className="login-modal__content__form__reset"
            onClick={() => {
              const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!email || !email.length) {
                setError('E-mailadres is niet ingevuld.');
              } else if (!emailPattern.test(email)) {
                setError('Ongeldig e-mailadres.');
              } else {
                forgotPasswordMutation.mutate();
                setError(null);
              }
              window.gtag?.('event', 'forgot-password-modal_click_send-email', {
                event_category: 'Account',
                event_label: 'Forgot password click send email button',
              });
            }}
            isLoading={forgotPasswordMutation.isPending}
          >
            Verstuur e-mail
          </Button>
        )}
      </div>
    </div>
  )
}

export default ForgotPassword;